import type { IconProps } from '@phosphor-icons/react';
import { CalendarBlank, CaretDown, CaretLeft, CaretRight, Clock } from '@phosphor-icons/react';
import type { ComponentType } from 'react';
import { forwardRef } from 'react';

/**
 * Icon components for the MUI X picker/calendar `slots` (openPickerIcon, leftArrowIcon,
 * rightArrowIcon, switchViewIcon) — wired via defaultProps in src/theme/components.ts.
 *
 * MUI X passes `ownerState` to every slot component; Phosphor icons spread unknown props
 * onto the `<svg>`, so a bare Phosphor icon in a slot triggers React's unknown-prop warning.
 * The wrapper strips `ownerState` before rendering (same pattern as Avatar's AvatarFallback).
 */
function pickerSlotIcon(Icon: ComponentType<IconProps>, name: string) {
  const Wrapped = forwardRef<SVGSVGElement, IconProps & { ownerState?: unknown }>(function PickerSlotIcon(
    { ownerState, ...props },
    ref
  ) {
    void ownerState;
    return <Icon ref={ref} {...props} />;
  });
  Wrapped.displayName = name;
  return Wrapped;
}

export const PickerCalendarIcon = pickerSlotIcon(CalendarBlank, 'PickerCalendarIcon');
export const PickerClockIcon = pickerSlotIcon(Clock, 'PickerClockIcon');
export const PickerLeftArrowIcon = pickerSlotIcon(CaretLeft, 'PickerLeftArrowIcon');
export const PickerRightArrowIcon = pickerSlotIcon(CaretRight, 'PickerRightArrowIcon');
export const PickerSwitchViewIcon = pickerSlotIcon(CaretDown, 'PickerSwitchViewIcon');
